import { getIn } from 'formik';
import { composeValidators, isRequired, matchesPattern } from 'revalidate';

export const processValidate = (
  name,
  validate = [],
  { required, pattern, publishRequiredOnly } = {}
) => {
  const shouldRequire = required && !publishRequiredOnly;

  if (!validate.length && !shouldRequire && !pattern) {
    return null;
  }

  let validators = validate.splice(0);

  if (shouldRequire) {
    validators = [...validators, isRequired];
  }

  if (pattern) {
    validators = [...validators, matchesPattern(new RegExp(pattern))];
  }

  return composeValidators(...validators)(name);
};

export const getValidity = (touched, error, hasAttemptedSubmit) => ({
  valid: !!(touched && !error),
  invalid: !!((touched && error) || (hasAttemptedSubmit && error)),
});

export const getFieldError = (form, fieldName) => {
  const fieldError = getIn(form.errors, fieldName);

  if (fieldError) {
    return fieldError;
  }

  if (form.status && form.status.publishAttempted) {
    return getIn(form.status.publishValidationErrors, fieldName);
  }

  return fieldError;
};
